/**
 *
 * ArrowButton
 *
 */

import * as PropTypes from "prop-types";
import styled from "styled-components";
import Arrow from "images/Arrow";

function noop() {}

function ArrowButton({
  disabled,
  onClick,
  left,
  up,
  down,
  label,
  transparent,
  color,
  id,
}) {
  const clickHandler = onClick || noop;
  const localColor = color || "Black";

  return (
    <StyledButton
      disabled={disabled}
      type="button"
      onClick={clickHandler}
      id={id}
    >
      <Wrapper>
        <Arrow
          color={localColor}
          left={left}
          down={down}
          up={up}
          disabled={disabled}
          transparent={transparent}
        />
      </Wrapper>
      {label && label.length !== 0 && <p>{label}</p>}
    </StyledButton>
  );
}

/**
 *
 * @param disabled
 * @param theme
 * @returns {string}
 */
function buttonColor({ disabled, theme }) {
  if (disabled) {
    return theme.disabledColor;
  }
  return "black";
}

const StyledButton = styled.button`
  outline: none;
  cursor: ${({ disabled }) => (disabled ? "default" : "pointer")};
  p {
    color: ${buttonColor};
  }
`;

const Wrapper = styled.div`
  width: 14px;
  height: 14px;
`;

ArrowButton.propTypes = {
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  left: PropTypes.bool,
  up: PropTypes.bool,
  down: PropTypes.bool,
  label: PropTypes.string,
  transparent: PropTypes.bool,
  color: PropTypes.string,
  id: PropTypes.string,
};

export default ArrowButton;
